export default function radiusToText (radius: number): string {
  switch (radius) {
    case 1:
      return 'one mile';
    case 10:
      return 'ten miles';
    case 100:
      return '100 miles';
    default:
      return 'ten miles';
  }
}
